import PropTypes from 'prop-types'
import React from "react";
import "./SensorFooter.scss"
import Kpi from "./Kpi/Kpi";
function SensorFooter({ sensor }) {
    if (!sensor) {
        return null
    }
    return <div className={"sensor-footer-container"}>
      
       { sensor.kpis.map((kpi,index)=>{
            return  <div key={index} className={"sensor-footer-item"} >
                 <Kpi caption={kpi.title} pct={kpi.value}/>
                </div>
        })}
    </div>
}
export default SensorFooter;

SensorFooter.propTypes = {
}
